import React from 'react'
import { useSelector } from 'react-redux'

import { GlgModal, GlgProgressBar } from 'Shared/components'

import { selectCloneLeaguesSessionByID } from '../../reducers/clone_leagues_sessions'
import useSessionStatusModal from '../../hooks/useSessionStatusModal'
import useSessionStatusData from '../../hooks/useSessionStatusData'
import SessionStatsChips from './SessionStatsChips'
import SessionStatusSearch from './SessionStatusSearch'
import SessionStatusTable from './SessionStatusTable'

const SessionStatusModal = () => {
  const { sessionID, shouldDisplayModal, closeModal } = useSessionStatusModal()
  const currentSession = useSelector(selectCloneLeaguesSessionByID(sessionID))
  const { totalJobsCount, processedJobsCount, percentage } = useSessionStatusData()
  
  return (<>
    { shouldDisplayModal ?
      <GlgModal contentClassName={'cls-status-modal'}>
          <span className={'modal-title-container'}>
            <span className={'title'}>{window.I18n.t('clone_leagues_sessions.general.cloning_session')}</span>
            <span className={'close-button'} onClick={() => closeModal()}>X</span>
          </span>
          <div className={'modal-content-container'}>
            <div className={'progress-container'}>
              <span className={'progress-title'}>{currentSession?.name}</span>
              <GlgProgressBar
                percentage={percentage}
                barClassName={'progress-bar'}
                fillClassName={totalJobsCount === processedJobsCount ? 'progress-fill-completed' : 'progress-fill'}
              />
              <span className={'progress-extras-container'}>
                <span className={totalJobsCount === processedJobsCount ? 'progress-extras-text completed' : 'progress-extras-text'}>
                  {totalJobsCount === processedJobsCount ?
                    <>{window.I18n.t('clone_leagues_sessions.general.completed')}
                      <i className="fa-solid fa-circle-check completed-icon"/></> :
                    `${window.I18n.t('clone_leagues_sessions.general.cloning')}...`
                  }
                </span>
                {totalJobsCount !== processedJobsCount &&
                  <span className={'progress-extras-text'}>
                    {processedJobsCount}/{totalJobsCount} {window.I18n.t('clone_leagues_sessions.status.completed')}
                  </span>
                }
              </span>
            </div>
            <SessionStatsChips />
            <SessionStatusSearch />
            <SessionStatusTable />
          </div>
      </GlgModal>
      : null
    }
  </>)
}

export default SessionStatusModal
